import { useParams, useSearchParams } from "react-router-dom";
import { useLectureContent } from "./hooks/useLectureContent";
import Hero from "@/components/Hero";
import Loader from "@/components/Loader";
import ContentList from "./components/ContentList";
import MaterialList from "./components/MaterialList";

function LectureDetials({ children }) {
    const [searchParams] = useSearchParams();
    const { courseId, lectureId, grade } = useParams();

    const page = searchParams.get("page")
        ? parseInt(searchParams.get("page"), 10) < 1
            ? 1
            : parseInt(searchParams.get("page"), 10)
        : 1;

    const includeFields = [
        "validQuestionsCount",
        "quizAttemptsMinScorePercentage",
        "quizAttemptsMaxScorePercentage",
        "quizAttemptsAvgScorePercentage",
    ];

    let year;
    if (grade === "1") {
        year = "الصف الأول الثانوي";
    }
    if (grade === "2") {
        year = "الصف الثاني الثانوي";
    }
    if (grade === "3") {
        year = "الصف الثالث الثانوي";
    }

    const include = [
        { field: "IsLocked", value: "true" },
        { field: "MyViews", value: "true" },
        { field: "IsAttended", value: "true" },
        { field: "IsSuccess", value: "true" },
        { field: "VideoDuration", value: "true" },
        { field: "RealSubmits", value: "true" },
        { field: "AttemptCount", value: "true" },
    ];

    const {
        isPending: LectureDataLoading,
        lectureContent,
        error,
    } = useLectureContent({
        courseId,
        lectureId,
        apiOperations: {
            include,
            includeFields,
            page,
            perPage: 7,
        },
    });

    if (
        LectureDataLoading ||
        error?.response?.status === 401 ||
        error?.response?.status === 403 ||
        error?.response?.status === 404
    )
        return (
            <div className="flex items-center justify-center h-screen">
                <Loader />
            </div>
        );

    const totalPages = Math.ceil(
        lectureContent?.meta.total / lectureContent?.meta.per_page
    );

    return (
        <>
            <Hero
                title="مادة اللغة العربية"
                isLoading={LectureDataLoading}
                description={lectureContent?.data[0]?.attributes?.name
                    .split(" ")
                    .splice(0, 10)
                    .join(" ")}
                pagesLinks={[
                    {
                        name: lectureContent?.data[0]?.attributes?.name
                            .split(" ")
                            .splice(0, 10)
                            .join(" "),
                        link: ``,
                    },
                    { name: "الرئيسية", link: "/" },
                    { name: year, link: `/${grade}/courses/${courseId}` },
                    { name: "الفصول الدراسية", link: `/${grade}/courses` },
                    {
                        name: "المحاضرات",
                        link: `/${grade}/courses/${courseId}`,
                    },
                ]}
            />
            <section className="container px-4 pt-20 mx-auto md:px-1">
                <div className="flex flex-col-reverse items-center justify-center gap-10 xl:flex-row">
                    <div className="w-full gap-16 xl:w-auto">
                        <ContentList
                            data={lectureContent?.data}
                            page={page}
                            totalPages={totalPages}
                        />
                        <MaterialList
                            data={lectureContent?.data}
                            page={page}
                            totalPages={totalPages}
                        />
                    </div>

                    <div className="self-start w-full h-full">{children}</div>
                </div>
            </section>
        </>
    );
}

export default LectureDetials;
